export const timelineDefaults = [
  {
    id: 'event-start',
    time: '',
    name: 'Event Start',
    description: '',
    music: '',
    notes: ''
  },
  {
    id: 'cocktail-hour',
    time: '',
    name: 'Cocktail Hour',
    description: '',
    music: '',
    notes: ''
  },
  {
    id: 'grand-entrance',
    time: '',
    name: 'Grand Entrance',
    description: '',
    music: '',
    notes: ''
  },
  {
    id: 'hora-dancing',
    time: '',
    name: 'Hora Dancing',
    description: '',
    music: '',
    notes: ''
  },
  {
    id: 'chair-lifting',
    time: '',
    name: 'Chair Lifting',
    description: '',
    music: '',
    notes: ''
  },
  {
    id: 'first-dance-set',
    time: '',
    name: 'First Dance Set',
    description: '',
    music: '',
    notes: ''
  },
  {
    id: 'main-reception-starts',
    time: '',
    name: 'Main Reception Starts',
    description: '',
    music: '',
    notes: ''
  },
  {
    id: 'first-dance',
    time: '',
    name: 'First Dance',
    description: '',
    music: '',
    notes: ''
  },
  {
    id: 'dinner',
    time: '',
    name: 'Dinner',
    description: '',
    music: '',
    notes: ''
  },
  {
    id: 'video-montage',
    time: '',
    name: 'Video Montage',
    description: '',
    music: '',
    notes: ''
  },
  {
    id: 'kidush-hamotzi',
    time: '',
    name: 'Kidush / Hamotzi',
    description: '',
    music: '',
    notes: ''
  },
  {
    id: 'first-course',
    time: '',
    name: 'First Course',
    description: '',
    music: '',
    notes: ''
  },
  {
    id: 'main-course',
    time: '',
    name: 'Main Course',
    description: '',
    music: '',
    notes: ''
  },
  {
    id: 'candle-lighting',
    time: '',
    name: 'Candle Lighting',
    description: '',
    music: '',
    notes: ''
  },
  {
    id: 'speeches',
    time: '',
    name: 'Speeches',
    description: '',
    music: '',
    notes: ''
  },
  {
    id: 'open-dancing',
    time: '',
    name: 'Open Dancing',
    description: '',
    music: '',
    notes: ''
  },
  {
    id: 'cake-cutting',
    time: '',
    name: 'Cake Cutting',
    description: '',
    music: '',
    notes: ''
  },
  {
    id: 'dessert',
    time: '',
    name: 'Dessert',
    description: '',
    music: '',
    notes: ''
  },
  {
    id: 'grand-finale',
    time: '',
    name: 'Grand Finale',
    description: '',
    music: '',
    notes: ''
  },
  {
    id: 'last-song',
    time: '',
    name: 'Last Song',
    description: '',
    music: '',
    notes: ''
  },
  {
    id: 'father-daughter-dance',
    time: '',
    name: 'Father-Daughter Dance',
    description: '',
    music: '',
    notes: ''
  },
  {
    id: 'mother-son-dance',
    time: '',
    name: 'Mother-Son Dance',
    description: '',
    music: '',
    notes: ''
  },
  {
    id: 'host-hostess-dance',
    time: '',
    name: 'Host and Hostess Dance',
    description: '',
    music: '',
    notes: ''
  }
];